import { BankserviceResponse } from '@ps20/bff-models';

export function formatIban(iban: string): string {
  return iban.replace(/([A-Z]{2}\d{2})(\d{4})(\d{4})(\d{4})(\d{4})(\d{2})/, '$1 $2 $3 $4 $5 $6');
}
export function removeBlanksFromIban(iban: string): string {
  return iban == null ? iban : iban.replace(/\s+/g, '');
}

export function formatBankname(resp: BankserviceResponse): string {
  let bankname =
    resp.institutName && resp.institutName.length > 0
      ? resp.institutName.split(',')[0].toUpperCase()
      : '';
  if (bankname.includes('&')) {
    bankname = bankname.replace(/&+/g, 'U.');
  }
  return bankname;
}

export function formatBanknameFromString(input: string): string {
  let bankname = input && input.length > 0 ? input.split(',')[0].toUpperCase() : '';
  if (bankname.includes('&')) {
    bankname = bankname.replace(/&+/g, 'U.');
  }
  return bankname;
}
